import React from 'react';
import Layout from '../../shared/components/Layout';
import Complete from '@/components/Complete';

const TerminateRequestComplete: React.FC = () => {
  return (
    <React.Fragment>
      <Layout>
        <Complete id="page-facility_login" heading="解約完了" content="解約が完了しました。"isFacility={false}  />
      </Layout>
    </React.Fragment>
  )
}

export default TerminateRequestComplete;